import React from "react";

const Overlay = ({ isOpen, onClick }) => (
  isOpen && <div className="overlay" onClick={onClick} />
);

export default Overlay;
